var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thirdQR[data-v-b4d1b650]{width:30px;height:30px;background-color:#ef565c;-o-object-fit:scale-down;object-fit:scale-down;-webkit-mask-image:url(" + escape(require("../../../../assets/mobil/expired.png")) + ");-webkit-mask-size:100% 100%;margin-right:3px}[data-v-b4d1b650] .v-list__tile{height:auto}", ""]);

// exports
